import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, ListItemSecondaryAction } from '@material-ui/core';

import pivotIcon from 'assets/svgs/pivot.svg';
import styles from './TimeElements.style';
import { setPivotOptions } from '../Preview.actions';
import { isMTS } from '../filter/FilterCondition';
import {
	PIVOT_SINGLE_TIME_VALUES,
	PIVOT_SINGLE_TIME_VALUE_MAP,
	PIVOT_MTS_VALUE,
	STYLE_CONSTANTS,
	WALMART_CALENDAR_WEEK
} from 'constants/constant';

/**
 * Pivot for Single time selection
 */
const PivotForTime = ({ isHovered, technicalName }) => {
	const classes = styles();
	const dispatch = useDispatch();
	const { filterList, selectedList, pivotOpts } = useSelector((state) => state.previewReducer);

	let hidePivot = false;
	/**
	 * 1. Hide Pivot if multiple time attributes are selected
	 * 2. Hide Pivot on others, if filter is already applied on an attribute
	 */
	if (selectedList.length > 0) {
		const selectedTimeAttributeCount = selectedList.reduce(
			(sum, item) => (sum = PIVOT_SINGLE_TIME_VALUES.includes(item?.technicalName) ? sum + 1 : sum),
			0
		);
		hidePivot = selectedTimeAttributeCount > 1 ? true : false;
	}
	if (filterList.length > 0) {
		const filterWhichHasPivot = filterList.find(
			(item) => PIVOT_SINGLE_TIME_VALUES.includes(item?.technicalName) && item?.field
		);
		if (filterWhichHasPivot && filterWhichHasPivot.technicalName !== technicalName) {
			hidePivot = true;
		}
	}

	const onPivotClick = (e) => {
		e.stopPropagation();
		pivotOpts.showPopup = pivotOpts && pivotOpts?.showPopup ? false : true;
		dispatch(setPivotOptions({ ...pivotOpts }));
	};

	if (hidePivot) {
		return null;
	}

	/**
	 * Show PivotIcon
	 * - Item is hovered, or
	 * - Pivot is applied on the Time attribute
	 * Exception: For 'Hourly Store Inventory' template, Pivot is available for Hour, of parent 'dimensions'
	 */
	const marginRight = technicalName === 'snap_shot_hour' ? '54px' : '24px';
	let visibility =
		isHovered || pivotOpts?.pivotColumn === technicalName
			? STYLE_CONSTANTS.VISIBLE
			: STYLE_CONSTANTS.HIDDEN;

	// Case: select week filter -> pivot on week filter -> create report -> edit. In this case, the technicalName is 'walmart_year_and_week'
	// but the technicalName for the pivot column is set as 'wm_time_window_week'
	const isMTSTwo = filterList.find((el) => isMTS(el));
	const weekTechnicalNames = [
		PIVOT_SINGLE_TIME_VALUE_MAP.WMT_YEAR_AND_WEEK,
		PIVOT_MTS_VALUE,
		WALMART_CALENDAR_WEEK
	];
	if (
		weekTechnicalNames.includes(pivotOpts?.pivotColumn) &&
		weekTechnicalNames.includes(technicalName) &&
		!isMTSTwo
	) {
		visibility = STYLE_CONSTANTS.VISIBLE;
	}

	return (
		<ListItemSecondaryAction>
			<Box style={{ visibility }} className={classes.rightAligned} marginRight={marginRight}>
				<img
					src={pivotIcon}
					alt="rb-pivot-icon"
					id="rb-pivot-icon"
					className={classes.pivotIcon}
					onClick={(e) => onPivotClick(e)}
				/>
			</Box>
		</ListItemSecondaryAction>
	);
};

export default PivotForTime;
